export default "__VITE_ASSET__B_v$Ec9P__";